import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from "echarts"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import Vant from "vant"
import "vant/lib/index.css"
import X2JS from 'x2js'
import "vue-easytable/libs/theme-default/index.css"
import VueEasytable from "vue-easytable"

Vue.prototype.$x2js = new X2JS()
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(Vant)
Vue.use(ElementUI)
Vue.use(VueEasytable)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
